@if (showTextSelectionOverlay()) {
  @for (rect of this.selectedWordsRect(); track $index) {
    <ct-shared-overlay-rect
      styleClasses="bg-primary opacity-50"
      [rect]="rect"
      [dimension]="dimension()" />
  }
  @let _lasso = lasso();
  @if (_lasso) {
    <ct-shared-overlay-rect
      styleClasses="bg-blue-400 opacity-50"
      [rect]="_lasso"
      [dimension]="dimension()" />
  }
}

@let currentHighlight = highlight();
@if (currentHighlight) {
  <div
    class="absolute"
    #fieldHighlight
    [ngStyle]="unionRect() | scaleRect: dimension() | rectDisplayStyle"></div>
  @for (partialSelection of currentHighlight.selection; track $index) {
    @for (wordRect of partialSelection; track $index) {
      <div
        class="bg-primary absolute opacity-30"
        [ngStyle]="wordRect | scaleRect: dimension() | rectDisplayStyle"></div>
    }
  }
}
